import trim from 'lodash/trim';
import { setWindowLocation } from 'js-utils/http';
import { logCheckpointOnPageChange } from 'js-utils/janus';
import {
    getCanonicalSearchUrl,
    constants as destinationConstants,
} from '@eb/destination-utils';

import { getExperimentId } from '../../utils/feed';

import {
    GA_HOME_FEED_CATEGORY,
    GA_HOME_CATEGORY,
    GA_RUN_SEARCH_ACTION,
    GA_RUN_SEARCH_HEADER_RECENT,
    GA_RUN_SEARCH_HEADER_POPULAR,
} from '../../constants/analytics';
import {
    RUN_SEARCH_HEADER,
    UPDATE_SEARCH_SUGGESTIONS,
} from '../../constants/constants';
import { parseSuggestions } from '../../utils/suggestions';

import { searchAutocompleteSuggestions as searchAutocompleteSuggestionsApi } from './api';

const SEARCH_HEADER_ACTIONS = {
    [destinationConstants.SUGGESTION_TYPE_HISTORY]: GA_RUN_SEARCH_HEADER_RECENT,
    [destinationConstants.SUGGESTION_TYPE_POPULAR]: GA_RUN_SEARCH_HEADER_POPULAR,
};

const trackHeaderSearch = ({ term, experimentId }) => ({
    type: 'RUN_SEARCH',
    meta: {
        analytics: {
            category: 'header',
            onWindowUnload: true,
            action: GA_RUN_SEARCH_ACTION,
            label: term,
            dimensions: {
                experimentId,
            },
        },
    },
});

const trackSearchHeader = ({
    query,
    locationSlug,
    actionType,
    loggedIn = true,
}) => ({
    type: 'RUN_SEARCH_HEADER',
    meta: {
        analytics: {
            category: loggedIn ? GA_HOME_FEED_CATEGORY : GA_HOME_CATEGORY,
            action: GA_RUN_SEARCH_ACTION,
            onWindowUnload: true,
            label: `${query}`,
            dimensions: {
                locationOnPage: 'Header',
                nameOfButton: SEARCH_HEADER_ACTIONS[actionType],
                urlParams: { location_slug: locationSlug },
            },
        },
    },
});

export const UPDATE_SEARCH_LOCATION_SLUG = 'UPDATE_SEARCH_LOCATION_SLUG';

export const updateSearchLocationSlug = (slug) => ({
    type: UPDATE_SEARCH_LOCATION_SLUG,
    payload: slug,
});

export const runSearch = (term) => (dispatch, getState) => {
    const state = getState();
    const {
        app: { domain, experiments },
        location: { slug, bbox, placeId },
    } = state;
    const experimentId = getExperimentId(experiments);
    const locationString = trim(slug) || 'local';
    const optionalParams = placeId ? {} : { bbox };

    const url = getCanonicalSearchUrl({
        slug: locationString,
        q: term,
        ...optionalParams,
    });

    logCheckpointOnPageChange(RUN_SEARCH_HEADER, domain)
        // Swallow errors since this shouldn't impact users at all
        .catch(() => null);

    dispatch(
        trackHeaderSearch({
            term,
            experimentId,
        }),
    );

    setWindowLocation(url);
};

const updateSearchAutocompleteSuggestions = (suggestions) => ({
    type: UPDATE_SEARCH_SUGGESTIONS,
    payload: suggestions,
});

export const searchAutocompleteSuggestions = (query) => (
    dispatch,
    getState,
) => {
    if (!query) {
        return dispatch(updateSearchAutocompleteSuggestions({}));
    }

    const {
        location: { placeId, isOnline },
    } = getState();

    return searchAutocompleteSuggestionsApi({
        placeId,
        onlineEventsOnly: isOnline,
        query,
    }).then((response) =>
        dispatch(
            updateSearchAutocompleteSuggestions(parseSuggestions(response)),
        ),
    );
};

export const searchFilterAction = (searchFilter) => (dispatch, getState) => {
    const { query, locationSlug, actionType } = searchFilter;

    const {
        user: { isAuthenticated },
        location: { bbox, placeId },
    } = getState();

    const locationString = trim(locationSlug) || 'local';
    const optionalParams = placeId ? {} : { bbox };

    const url = getCanonicalSearchUrl({
        slug: locationString,
        q: query,
        ...optionalParams,
    });

    dispatch(
        trackSearchHeader({
            query,
            locationSlug,
            actionType,
            loggedIn: isAuthenticated,
        }),
    );

    setWindowLocation(url);
};
